import { render, staticRenderFns } from "./serviceDefault.vue?vue&type=template&id=31f64446"
import script from "./serviceDefault.vue?vue&type=script&lang=js"
export * from "./serviceDefault.vue?vue&type=script&lang=js"
import style0 from "./serviceDefault.vue?vue&type=style&index=0&id=31f64446&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports